/**
 * Checks if the value is a number.
 *
 * This is a more "intuitive" version of the native `isNaN` function or `Number.isNaN`.
 *
 * The native functions `isNaN` and `Number.isNaN` are not intuitive because they return unexpected results, e.g.
 * `Number.isNaN("1blabla")` returns `false`, but one might expect it to be `true`, since "1blabla" does not
 * look much like a proper number. And futhermore `Number("1blabla")` is `NaN` indeed.
 *
 * To avoid confusion, you may use `lxIsNumber` or `lxIsNaN` instead.
 *
 * See [isNaN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isNaN)
 * and [Number.isNaN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN) in the MDN.
 *
 *
 * @example
 * lxIsNumber(1) // true
 * lxIsNumber("1") // false
 * lxIsNumber(NaN) // false
 * lxIsNumber(Infinity) // false
 *
 *
 * @package Utils
 */
export function lxIsNumber(value) {
    return typeof value === "number" && Number.isFinite(value);
}
